<template>
    <CSelect
        :isValid="isValid"
        :value.sync="country"
        :options="countries"
        @change="$emit('update:value',parseInt($event.target.value))" 
        
        :label="label"
        :placeholder="placeholder"
        :invalidFeedback="invalidFeedback"
        :horizontal="horizontal"
        :disabled="disabled"
        :size="size"
    />
</template>

<script>
import axios from 'axios';
export default {
    name: "SelectCountry",

    props: {
        isValid: {
            type: Boolean,
            default: null
        },
        label: {
            type:String,
            default: null
        },
        value:{
            default:null
        },
        horizontal:{
            default: false
        },
        placeholder:{
            default:null
        },
        invalidFeedback:{
            default:undefined
        },
        size:{
            default:undefined
        },
        disabled:{
            default:false
        }
        

    },
    data(){
        return{
            countries:[],
            country:null
        }
    },
    watch:{
        value(newValue){
            this.country = parseInt(newValue);
        }
    },
    methods:{
        async getCountries() {
            try {
                const {data} = await axios.get('/country');
                this.countries = data.map( country => {
                    return { value: country.id, label: country.name};
                })
            } catch (error) {
                console.log(error);
            }
        },
    },
    async mounted(){
        await this.getCountries();
        this.country = parseInt(this.value);
    }

}
</script>
<style>

</style>